import { useState, useEffect } from 'react';
import { getApiClient } from '../../api';

export const useUserPermissions = () => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userPermissionsResponse = await getApiClient().getAdminUserPermissions();
                setUser(userPermissionsResponse);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { user, loading, error };
};
